export {Menu} from 'antd';
export type {MenuState, MenuProps, MenuMode, SelectParam, ClickParam} from 'antd/es/menu/index';
